import axios from 'axios';
import { ROOT_URL, getAuthHeaders, isUnauthorizedError } from './constants';

// Constantes para el manejo de las matrices de codificación.


// Actualiza la matriz actual en la aplicación.
export const GET_API_ANSWERS_BY_MATRIX = 'GET_API_ANSWERS_BY_MATRIX';

export const GET_API_ANSWER_GRADERS_BY_ANSWER = 'GET_API_ANSWER_GRADERS_BY_ANSWER';


export function getAnswersByMatrix(matrixId, successCallback = () => {}, errorCallback = (error) => {}) {
  const request = axios.get(`${ROOT_URL}/api/answers/by_matrix?matrix_id=${matrixId}&exclude_bank=true`, getAuthHeaders());

  return (dispatch) => {
    request.then(({data}) => {
      dispatch({
        type: GET_API_ANSWERS_BY_MATRIX,
        payload: data
      });
      successCallback();
    }).catch((error) => {
      if(!isUnauthorizedError(error, dispatch)) {
        errorCallback(error);
      }
    });
  }
}


export function getAnswerGradersByAnswer(id, successCallback = () => {}, errorCallback = (error) => {}) {
  const request = axios.get(`${ROOT_URL}/api/answer_graders/by_answer?answer_id=${id}`, getAuthHeaders());

  return (dispatch) => {
    request.then(({data}) => {
      dispatch({
        type: GET_API_ANSWER_GRADERS_BY_ANSWER,
        payload: data
      });
      successCallback();
    }).catch((error) => {
      if(!isUnauthorizedError(error, dispatch)) {
        errorCallback(error);
      }
    });
  }
}

